<!--
 * @Description: 试题库 修改
 * @Author: PF
 * @Date: 2022-09-23 11:53:32
 * @LastEditors: PF
 * @LastEditTime: 2025-11-24 11:14:16
-->
<template>
  <div>
    <el-dialog class="wp85 hp85" :model-value="openEdit" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">修改</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openEdit', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-form ref="ruleFormRef" :model="ruleForm" label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="试题库">
              {{ ruleForm.zystkmc }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="适用类型" prop="sylx" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-checkbox-group v-model="ruleForm.sylx">
                <el-checkbox label="1" >考试</el-checkbox>
                <el-checkbox label="2" >作业</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="课程">
              {{ ruleForm.kcmc }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="学期数">
              {{ruleForm.xqsmc}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="教学单元" prop="jxdyid" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-select class="mr10" v-model="ruleForm.jxdyid" clearable filterable :teleported="false" style="width: calc(100% - 71px);" @change="ruleForm.jxnrid='';initjxnrList()">
                <el-option v-for="(item, index) in jxdyData" :key="index" :label="item.jxdybt" :value="item.id" />
              </el-select>
              <el-button type="primary" @click="openAddJiaoXueDanYuan=true;tcrow={kcid:ruleForm.kcid,kcmc:ruleForm.kcmc}">添加</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="教学内容" prop="jxnrid" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-select class="mr10" v-model="ruleForm.jxnrid" clearable filterable :teleported="false" style="width: calc(100% - 71px);">
                <el-option v-for="(item, index) in jxnrData" :key="index" :label="item.jxnrbt" :value="item.id" />
              </el-select>
              <el-button type="primary" @click="openAddJiaoXueNeiRong=true;tcrow={kcid:ruleForm.kcid,kcmc:ruleForm.kcmc,jxdyid:ruleForm.jxdyid}">添加</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="题型" prop="txid" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-select v-model="ruleForm.txid" clearable filterable :teleported="false" @change="txChange">
                <el-option v-for="item in txData" :key="item.id" :label="item.bt" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="难度" prop="nd" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-input-number v-model="ruleForm.nd" :min="0" :max="1.0" :step="0.1" :precision="1" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="区分度" prop="qfd" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-input-number v-model="ruleForm.qfd" :min="-1.00" :max="1.00" :step="0.1" :precision="2" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="建议考试得分" prop="jyksdf" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-input-number v-model="ruleForm.jyksdf" :min="0" :precision="1" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="保密度" prop="bmdid" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-select v-model="ruleForm.bmdid" :teleported="false">
                <el-option v-for="item in bmdzyData" :key="item.id" :label="item.bt" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="试题正文" prop="stzw" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <teditor ref="editor" v-model="ruleForm.stzw" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="参考选项" v-if="ruleForm.txid === zytxData.danXuan || ruleForm.txid === zytxData.duoXuan">
              <div class="wp100">
                <el-button type="primary" @click="addXuanXiang">添加选项</el-button>
                <el-button type="primary" v-if="xztxx.length > 2" @click="delXuanXiang">减少选项</el-button>
                <el-table class="mt10" :data="xztxx" style="width: 100%" border :show-header="false">
                  <el-table-column align="center" width="80" show-overflow-tooltip>
                    <template #default="scope">
                      {{ scope.row.xxbh }}
                    </template>
                  </el-table-column>
                  <el-table-column align="center" show-overflow-tooltip>
                    <template #default="scope">
                      <teditor ref="editor" v-model="scope.row.xxnr" :height="105" />
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item v-if="ruleForm.txid === zytxData.panDuan" label="答案" prop="xztckda" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <div class="wp100">
                <el-radio-group v-model="pdtckda" class="ml-4">
                  <el-radio :label="true">对</el-radio>
                  <el-radio :label="false">错</el-radio>
                </el-radio-group>
              </div>
            </el-form-item>
            <el-form-item v-else-if="ruleForm.txid === zytxData.tianKong" label="答案" prop="xztckda" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <div class="wp100">
                <el-button type="primary" @click="addTktxx">添加选项</el-button>
                <el-button type="primary" v-if="tktckdas.length > 1" @click="delTktxx">减少选项</el-button>
                <el-table class="mt10" :data="tktckdas" style="width: 100%" border :show-header="false">
                  <el-table-column align="center" show-overflow-tooltip>
                    <template #default="scope">
                      <teditor ref="editor" v-model="scope.row.tktckda" :height="105" />
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-form-item>
            <el-form-item v-else-if="ruleForm.txid === zytxData.danXuan" label="答案" prop="xztckda" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <div class="wp100">
                <el-radio-group v-model="xztckda">
                  <el-radio v-for="(item, index) in xztxx" :key="index" :label="item.xxbh">{{item.xxbh}}</el-radio>
                </el-radio-group>
              </div>
            </el-form-item>
            <el-form-item v-else-if="ruleForm.txid === zytxData.duoXuan" label="答案" prop="xztckda" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <div class="wp100">
                <el-checkbox-group v-model="xztckda">
                  <el-checkbox v-for="(item, index) in xztxx" :key="index" :label="item.xxbh" />
                </el-checkbox-group>
              </div>
            </el-form-item>
            <el-form-item v-else label="答案" prop="xztckda" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <div class="wp100">
                <teditor ref="editor" v-model="qttckda" />
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="解析">
              <teditor ref="editor" v-model="ruleForm.jx" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="评分标准">
              <teditor ref="editor" v-model="ruleForm.pfbz" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="考试要求">
              <ueditor v-model:value="ruleForm.ksyq" :tcrow="{height:100}" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" @click="submit()">保存</el-button>
            <el-button type="info" @click="closeWindow('openEdit', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
  <jiaoxuedanyuan v-if="openAddJiaoXueDanYuan" v-model:openAdd="openAddJiaoXueDanYuan" :row="tcrow" @ReturnData="initjxdyList" />
  <jiaoxueneirong v-if="openAddJiaoXueNeiRong" v-model:openAdd="openAddJiaoXueNeiRong" :row="tcrow" @ReturnData="initjxnrList" />
</template>

<script setup>
import { defineProps, defineEmits, ref, watch, unref } from 'vue'
import { loadData, loadSelect, submitEditForm, closeWindow } from '@/api/common.js'
import { loadZiDianSelect } from '@/api/queryZiDian.js'
import { warningPrompt } from '@/utils/promptInfo.js'
import { toChinesNum } from '@/utils/index.js'
import { getTiXing } from '@/utils/zidianmeiju'
import jiaoxuedanyuan from '@/components/jiaoxuedanyuan.vue'
import jiaoxueneirong from '@/components/jiaoxueneirong.vue'
import teditor from '@/components/teditor.vue'
import ueditor from '@/components/ueditor.vue'

const props = defineProps({
  openEdit: { type: Boolean, required: true },
  row: { required: false }
})
const emits = defineEmits(['update:openEdit', 'ReturnData'])

const ruleFormRef = ref(null)
const ruleForm = ref({})
const stkData = ref([]) // 试题库
const txData = ref([]) // 题型
const tlData = ref([]) // 题类
const bmdzyData = ref([]) // 保密度

const pdtckda = ref(null) // 判断题答案
const tktckdas = ref([{ tktckda: '' }, { tktckda: '' }]) // 填空题答案
const xztxx = ref([]) // 参考选项
const xztckda = ref() // 参考答案
const qttckda = ref(null) // 其他题答案

const tcrow = ref({})
const openAddJiaoXueDanYuan = ref(false)
const jxdyData = ref([])
const initjxdyList = () => {
  loadSelect({
    url: '/api/v2/ziyuanku/kechengjiaoxuedanyuan/list',
    parms: { kcid: ruleForm.value.zystkkcid, order: 'sx', sort: 'asc' },
    data: jxdyData
  })
}
const openAddJiaoXueNeiRong = ref(false)
const jxnrData = ref([])
const initjxnrList = () => {
  loadSelect({
    url: '/api/v2/ziyuanku/kechengjiaoxueneirong/list',
    parms: { jxdyid: ruleForm.value.jxdyid, order: 'sx', sort: 'asc' },
    data: jxnrData
  })
}
// 选择题型
const txChange = (val) => {
  tktckdas.value = []
  xztxx.value = []
  xztckda.value = null
  txData.value.forEach((element) => {
    if (val === element.id) {
      if (element.id === zytxData.value.panDuan) {
        tlData.value.forEach((e) => {
          if (e.bt === '客观题') {
            ruleForm.value.tlid = e.id
          }
        })
      } else if (element.id === zytxData.value.tianKong) {
        tlData.value.forEach((e) => {
          if (e.bt === '客观题') {
            ruleForm.value.tlid = e.id
          }
        })
        tktckdas.value = [{ tktckda: '' }, { tktckda: '' }]
      } else if (element.id === zytxData.value.danXuan) {
        tlData.value.forEach((e) => {
          if (e.bt === '客观题') {
            ruleForm.value.tlid = e.id
          }
        })
        xztxx.value = [
          { xxbh: 'A', xxnr: '' },
          { xxbh: 'B', xxnr: '' },
          { xxbh: 'C', xxnr: '' },
          { xxbh: 'D', xxnr: '' }
        ]
        xztckda.value = ''
      } else if (element.id === zytxData.value.duoXuan) {
        tlData.value.forEach((e) => {
          if (e.bt === '客观题') {
            ruleForm.value.tlid = e.id
          }
        })
        xztxx.value = [
          { xxbh: 'A', xxnr: '' },
          { xxbh: 'B', xxnr: '' },
          { xxbh: 'C', xxnr: '' },
          { xxbh: 'D', xxnr: '' }
        ]
        xztckda.value = []
      } else {
        tlData.value.forEach((e) => {
          if (e.bt === '主观题') {
            ruleForm.value.tlid = e.id
          }
        })
      }
    }
  })
}
// 添加选项
const addXuanXiang = () => {
  const letter = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J']
  const changDu = xztxx.value.length
  if (changDu > 10) {
    return warningPrompt('选项不能大于10个')
  }
  xztxx.value.push({ xxbh: letter[changDu], xxnr: '' })
}
// 减少选项
const delXuanXiang = (index) => {
  xztxx.value.pop(index, -1)
}
// 添加填空题选项
const addTktxx = () => {
  const changDu = tktckdas.value.length
  if (changDu > 10) {
    return warningPrompt('选项不能大于10个')
  }
  tktckdas.value.push({ tktckda: '' })
}
// 减少填空题选项
const delTktxx = (index) => {
  tktckdas.value.pop(index, -1)
}
const sjzykData = ref() // 上级栏目
const zytxData = ref({ list: [] }) // 上级栏目
const initInfo = (id) => {
  loadData({
    url: '/api/v2/ziyuanku/zhuanyeku/zhuanyeshiti/' + id,
    ruleForm: ruleForm,
    loadSuccess: function (res) {
      ruleForm.value = res.data
      initjxdyList()
      ruleForm.value.xqsmc = '第' + toChinesNum(Number(res.data.xqmc)) + '学期'
      ruleForm.value.stzw = res.data.zystkstzw // 专业试题库试题正文
      ruleForm.value.sylx = res.data.zystkstsylx.split(',') // 专业试题库试题适用类型1-考试 2-作业
      ruleForm.value.zystkstkid = res.data.zystkstkid // 专业试题库ID
      ruleForm.value.jxdyid = res.data.zystkstjxdyid // 专业试题库试题教学单元ID
      initjxnrList()
      ruleForm.value.jxnrid = res.data.zystkstjxnrid // 专业试题库试题教学内容ID
      ruleForm.value.nd = res.data.zystkstnd // 专业试题库试题难度
      ruleForm.value.qfd = res.data.zystkstqfd // 专业试题库试题区分度
      ruleForm.value.txid = res.data.zystksttx // 专业试题库试题题型
      ruleForm.value.jyksdf = res.data.zystkstjyksdf // 专业试题库试题建议考试得分
      ruleForm.value.bmdid = res.data.zystkstbmd // 专业试题库试题保密度
      ruleForm.value.pfbz = res.data.zystkstpfbz // 专业试题库试题评分标准
      ruleForm.value.jx = res.data.zystkstjx // 专业试题库试题解析
      ruleForm.value.ksyq = res.data.zystkstksyq // 专业试题库试题考试要求
      if (res.data.txid === zytxData.value.panDuan) {
      // 判断题参考答案
        pdtckda.value = Boolean(res.data.zystkstksda) || null
      } else if (ruleForm.value.txid === zytxData.value.tianKong) {
      // 填空题参考答案
        tktckdas.value = []
        tktckdas.value = res.data.tktckda.map(item => ({ tktckda: item }))
      } else if (ruleForm.value.txid === zytxData.value.danXuan) {
      // 单选
        // 参考选项
        xztxx.value = res.data.cankaolist.map(item => {
          item.xxbh = item.xxbh
          item.xxnr = item.xxnr
          return item
        })
        xztckda.value = res.data.zystkstksda
      } else if (ruleForm.value.txid === zytxData.value.duoXuan) {
      // 多选
        // 参考选项
        xztxx.value = res.data.cankaolist.map(item => {
          item.xxbh = item.xxbh
          item.xxnr = item.xxnr
          return item
        })
        xztckda.value = res.data.zystkstksda ? res.data.zystkstksda.split(',') : []
      } else {
      // 其他题参考答案
        qttckda.value = res.data.zystkstksda || ''
      }
    }
  })
}
watch(
  () => props.openEdit,
  () => {
    if (props.openEdit) {
      initjxdyList()
      zytxData.value = getTiXing()
      loadSelect({
        url: '/api/v2/ziyuanku/shitiku/tree',
        data: sjzykData,
        order: 'stkmc',
        sort: 'asc'
      })
      loadSelect({
        url: '/api/v2/ziyuanku/jiaoshishitiku/tree',
        parms: { order: 'createdTime', sort: 'asc' },
        data: stkData
      })
      loadZiDianSelect('题型', txData)
      loadZiDianSelect('题类', tlData)
      loadZiDianSelect('保密度', bmdzyData)
      initInfo(props.row.id)
    }
  },
  { deep: true, immediate: true }
)
// 提交
const submit = async () => {
  let obj = {}
  if (ruleForm.value.txid === zytxData.value.panDuan) {
    ruleForm.value.xztckda = pdtckda.value
  } else if (ruleForm.value.txid === zytxData.value.tianKong) {
    ruleForm.value.xztckda = tktckdas.value.map((item, index) => (index + 1) + ':' + item.tktckda)
  } else if (ruleForm.value.txid === zytxData.value.danXuan) {
    ruleForm.value.xztxx = xztxx.value
    ruleForm.value.xztckda = []
    ruleForm.value.xztckda.push(xztckda.value)
  } else if (ruleForm.value.txid === zytxData.value.duoXuan) {
    ruleForm.value.xztxx = xztxx.value
    ruleForm.value.xztckda = []
    ruleForm.value.xztckda = xztckda.value.sort(function compareFunction (param1, param2) { return param1.localeCompare(param2, 'zh') })
  } else {
    ruleForm.value.xztckda = qttckda.value
  }
  const form = unref(ruleFormRef)
  if (!form) return
  await form.validate()
  obj = {
    id: ruleForm.value.id,
    zystkstzw: ruleForm.value.stzw, // 专业试题库试题正文
    zystkstsylx: ruleForm.value.sylx.join(','), // 专业试题库试题适用类型1-考试 2-作业
    zystkstkid: ruleForm.value.zystkstkid, // 专业试题库ID
    zystkkcid: ruleForm.value.zystkkcid, // 专业试课程ID
    zystkstjxdyid: ruleForm.value.jxdyid, // 专业试题库试题教学单元ID
    zystkstjxnrid: ruleForm.value.jxnrid, // 专业试题库试题教学内容ID
    zystkstnd: ruleForm.value.nd, // 专业试题库试题难度
    zystkstqfd: ruleForm.value.qfd, // 专业试题库试题区分度
    zystksttx: ruleForm.value.txid, // 专业试题库试题题型
    zystkstjyksdf: ruleForm.value.jyksdf, // 专业试题库试题建议考试得分
    zystkstbmd: ruleForm.value.bmdid, // 专业试题库试题保密度
    zystkstksda: Array.isArray(ruleForm.value.xztckda) ? ruleForm.value.xztckda.join(',') : ruleForm.value.xztckda, // 专业试题库试题考试答案
    zystkstpfbz: ruleForm.value.pfbz, // 专业试题库试题评分标准
    zystkstjx: ruleForm.value.jx, // 专业试题库试题解析
    zystkstksyq: ruleForm.value.ksyq, // 专业试题库考试要求
    // zystkstckxxid: '', // 专业试题库试题参考选项ID
    listcankao: []
  }
  if (Array.isArray(ruleForm.value.xztxx)) {
    ruleForm.value.xztxx.forEach(element => {
      obj.listcankao.push({
        id: element.id,
        xxbh: element.xxbh, // 专业试题库试题参考选项序号
        xxnr: element.xxnr, // 专业试题库试题参考选项内容
        stid: ruleForm.value.id // 专业试题库试题ID
      })
    })
  }
  submitEditForm({
    url: '/api/v2/ziyuanku/zhuanyeku/zhuanyeshiti',
    ruleFormRef: unref(ruleFormRef),
    ruleForm: obj,
    callback: function () {
      closeWindow('openEdit', emits, true)
    }
  })
}
</script>
